import {Chip} from "@mui/material";
import {getLabelEstado} from "../../shared/estados";
import {getSituacaoOcorrencia} from "../../shared/situacaoOcorrencia";

function LabelEstado({estado, label, ocorrencia}) {
    if (!estado) return null;

    let color;

    switch (estado) {
        case "AGUARDANDO_APROVACAO":
            color = "info";
            break;
        case "EM_FILA":
            color = "default";
            break;
        case "PROCESSAMENTO":
            color = "warning";
            break;
        case "PROCESSADO_COM_SUCESSO":
            color = "success";
            break;
        case "PROCESSADO_COM_ERRO":
            color = "error";
            break;
        case "RESULTADO_INDETERMINADO":
            color = "warning";
            break;
        default:
            color = "default";
    }

    const situacao = ocorrencia ? getSituacaoOcorrencia(ocorrencia) : null;
    return (
        <Chip
            label={situacao?.label || label || getLabelEstado(estado)}
            title={situacao?.descricao}
            variant="outlined"
            size="small"
            color={situacao?.color || color}
            sx={{
                marginX: 2,
                height: "auto",
                minHeight: 24,
                "& .MuiChip-label": {whiteSpace: "normal", py: 0.5}
            }}
        />
    );
}

export default LabelEstado;
